// Firebase initialisation.
//
// Imports vendor.js rather than assuming it: ES modules evaluate in import
// order, and firebase.initializeApp() below needs window.firebase to exist. Any
// module that needs db or auth imports them from here, so they can never again
// be consts that only script.js can see.
import '../vendor.js';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Fail at startup with a clear message rather than letting Firebase throw
// something opaque several frames deep when a variable is missing.
for (const [key, value] of Object.entries(firebaseConfig)) {
  if (!value) {
    throw new Error(
      `Firebase config is missing ${key}. Check .env for the matching VITE_FIREBASE_* variable.`
    );
  }
}


// Firebase initialization
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebase.database();
export const auth = firebase.auth();
